<script setup lang="ts">
import {Extension, ProgramExtension} from "@/core/interfaces/extension/Extension";
import {ExtensionGrid} from "@/extension/components/extension-grid";

defineEmits<{
    (e: 'extensionClick', extension: Extension): void;
}>();
const props = defineProps<{
    programExtensions: ProgramExtension[]
    appendsIcon: boolean;
    enableToggle?: boolean;
}>();

const filterProgramType = (type: string) => {
    return props.programExtensions.filter(extension => extension.sub_type === type);
};
</script>

<template>
  <ExtensionGrid
    :appends-icon="appendsIcon"
    :title="'Programmes'"
    :extensions="filterProgramType('support')"
    :enable-toggle="enableToggle"
    @extension-click="(extension) => $emit('extensionClick', extension)"
  />
  <ExtensionGrid
    :title="'Services'"
    :appends-icon="appendsIcon"
    :extensions="filterProgramType('feature')"
    :enable-toggle="enableToggle"
    @extension-click="(extension) => $emit('extensionClick', extension)"
  />
  <ExtensionGrid
    :title="'Offres Commerciales'"
    :appends-icon="appendsIcon"
    :extensions="filterProgramType('discount')"
    :enable-toggle="enableToggle"
    @extension-click="(extension) => $emit('extensionClick', extension)"
  />
  <ExtensionGrid
    :title="'Cartes de Fidélité'"
    :appends-icon="appendsIcon"
    :extensions="filterProgramType('loyalty-card')"
    :enable-toggle="enableToggle"
    @extension-click="(extension) => $emit('extensionClick', extension)"
  />
</template>
